import { ElementFormatType, ElementNode, TextNode } from 'lexical';
import * as Constants from 'const';
import { DefaultAlign, DefaultFontFamily } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';
import { getIntegerFromStyle } from 'utils/getIntegerFromStyle';
import { toPx } from 'utils/toPx';
import { $getTextNodeStyleValueForProperty } from '../../lexicalUtils';
import { $isSSIAnchorNode } from '../../nodes/SSIAnchorNode';
import { FontPluginStyle } from '../../Plugins/FontPlugin/style';

export const paragraphDefaultValues: Omit<Schemas.Paragraph, 'type' | 'segments'> = {
  align: DefaultAlign,
  lineHeight: String(Constants.DefaultLineHeight),
  fontFamily: DefaultFontFamily,
  fontSize: toPx(Constants.DefaultCustomStyle.FONT_SIZE),
  color: Constants.DefaultCustomStyle.FONT_COLOR as string,
  anchor: false,
};

export function getParagraphFontSize(
  firstTextNode: TextNode | undefined,
  defatulFontSize: number,
  projectType: Constants.ProjectType,
): number {
  const { allowCustomRangeFontSizeSelection } = Constants.ProjectsConfig[projectType];

  if (allowCustomRangeFontSizeSelection) {
    return defatulFontSize;
  }

  if (!firstTextNode) {
    return defatulFontSize;
  }

  const value = $getTextNodeStyleValueForProperty(firstTextNode, FontPluginStyle.FONT_SIZE, '');

  // only integer is used for fontSize value
  return value ? getIntegerFromStyle(value) : defatulFontSize;
}

export function getParagraphLineHeight(
  nodeLineHeight: number | undefined,
  nodeFontSizeNumber: number | undefined,
  defaultLineHeight: number,
  lineheightNoPx = false,
): string {
  const lineHeight = nodeLineHeight && nodeLineHeight > 0 ? nodeLineHeight : defaultLineHeight;

  if (lineheightNoPx) {
    return lineHeight.toString();
  }

  return nodeFontSizeNumber ? toPx(nodeFontSizeNumber * lineHeight, 2) : toPx(lineHeight);
}

export function getParagraphAlign(
  nodeFormatType: ElementFormatType,
  alignmentOverride: string | undefined,
): Schemas.Align['align'] {
  if (alignmentOverride) {
    return alignmentOverride;
  }
  const formatTypeToAlignMap: Record<Exclude<ElementFormatType, ''>, string> = {
    left: 'left',
    start: 'left',
    center: 'center',
    right: 'right',
    end: 'right',
    justify: 'justify',
  };
  const align = nodeFormatType ? formatTypeToAlignMap[nodeFormatType] : undefined;

  return align ?? DefaultAlign;
}

export function getParagraphAnchor(
  node: ElementNode,
): boolean {
  return Boolean(node.getChildren().find($isSSIAnchorNode));
}
